import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-yes-no',
  templateUrl: './modal-yes-no.component.html',
  styleUrls: ['./modal-yes-no.component.scss']
})
export class ModalYesNoComponent implements OnInit {

  message: String;
  yesIsDanger = false;
  noIsDanger = false;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  close(value) {
    return this.activeModal.close(value);
  }

}
